/**
 * AI/ML Configuration
 * Centralized configuration for AI services and parameters
 */

export const AI_CONFIG = {
  // Gemini API parameters
  GEMINI: {
    GENERATION_CONFIG: {
      temperature: 0.2,
      topK: 20,
      topP: 0.85,
      maxOutputTokens: 4096,
      thinkingConfig: {
        thinkingBudget: 2048,
      },
    },
    
    SAFETY_SETTINGS: [
      {
        category: 'HARM_CATEGORY_HARASSMENT',
        threshold: 'BLOCK_MEDIUM_AND_ABOVE',
      },
      {
        category: 'HARM_CATEGORY_HATE_SPEECH',
        threshold: 'BLOCK_MEDIUM_AND_ABOVE',
      },
    ],

    // Prompt templates
    PROMPTS: {
      FILTER_EXTRACTION: 'Extract filters from user query',
      KEYWORD_EXTRACTION: 'Extract keywords for search',
      TRACK_METADATA: 'Generate track metadata suggestions',
    },
  },

  // Chatbot configuration
  CHATBOT: {
    MAX_HISTORY_LENGTH: 50,
    RESPONSE_TIMEOUT: 30000,
    MAX_RETRIES: 3,
  },

  // Keywords and extraction settings
  KEYWORDS: {
    MIN_LENGTH: 2,
    MAX_SUGGESTIONS: 10,
    CONFIDENCE_THRESHOLD: 0.7,
  },
};

export default AI_CONFIG;